import * as head from "modules/head";
import * as activity from "modules/activity";
import * as audiences from "modules/audiences";
import { reducer as config } from "modules/config/reducer";
import * as documents from "modules/documents";
import * as events from "modules/events";
import * as gallery from "modules/gallery";
import * as insights from "modules/insights";
import { reducer as localization } from "modules/localization/reducer";
import * as portalPages from "modules/portalPages";
import * as posts from "modules/posts";
import * as profile from "modules/profile";
import * as resources from "modules/resources";
import * as settings from "modules/settings";
import * as surveys from "modules/surveys";
import * as tenant from "modules/tenant";
import * as users from "modules/users";
import * as messaging from "modules/messaging";
import * as categoryTags from "modules/categorytags";
import * as adminLayout from "modules/adminLayout";
import * as userPortalLayout from "modules/userPortalLayout";

import { ReducersMapObject } from "redux";
import { GlobalApplicationState } from "globalApplicationState";
import { globalLayoutSlice } from "modules/globalLayout/reducer";
import { contentBandsSlice } from "modules/contentBands/reducer";
import { homeScreensSlice } from "modules/homeScreens/reducer";
import { guidelinesSlice } from "modules/settings/components/content/guidelines/reducer";
import { emailsSlice } from "modules/emails/reducer";
import { smsSlice } from "modules/sms/reducer";
import { snackbarsSlice } from "modules/common/components/snackbars/reducer";
import { shortcutsSlice } from "modules/shortcuts/reducer";
import { digitalScreensSlice } from "modules/digitalScreens/reducer";
import { topicSlice } from "modules/topics/reducer";

export const reducers: ReducersMapObject<GlobalApplicationState, any> = {
    activity: activity.reducers.activity,
    adminLayout: adminLayout.reducers.adminLayoutReducer,
    audiences: audiences.reducers.audiences,
    snackbars: snackbarsSlice.reducer,
    categoryTags: categoryTags.reducers.categoryTags,
    config,
    contentBands: contentBandsSlice.reducer,
    digitalScreens: digitalScreensSlice.reducer,
    documents: documents.reducers.documents,
    emails: emailsSlice.reducer,
    sms: smsSlice.reducer,
    events: events.reducers.events,
    head: head.reducers.head,
    homeScreenConfigs: homeScreensSlice.reducer,
    insights: insights.reducers.insights,
    gallery: gallery.reducers.gallery,
    guidelines : guidelinesSlice.reducer,
    localization: localization,
    messaging: messaging.reducers.messaging,
    portalPages: portalPages.reducers.portalPages,
    posts: posts.reducers.posts,
    profile: profile.reducers.profile,
    resources: resources.reducers.resources,
    settings: settings.reducers.settings,
    shortcuts: shortcutsSlice.reducer,
    surveys: surveys.reducers.surveys,
    tenant: tenant.reducers.tenant,
    topics: topicSlice.reducer,
    users: users.reducers.users,
    globalLayout: globalLayoutSlice.reducer,
    userPortalLayout: userPortalLayout.reducers.userPortalLayoutReducer,
};

export default reducers;
